import * as React from 'react';
import { SVGProps } from 'react';

const SvgDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9 1H4.5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6.4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Zm8.6 10h-15a1 1 0 1 0 0 2h15a1 1 0 1 0 0-2Zm0-10h-2.08a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2.08a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1Zm0 16h-2.08a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2.08a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1Zm-8.6 0H4.5a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6.4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1ZM2.5 2a2 2 0 0 1 2-2h6.4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4.5a2 2 0 0 1-2-2V2Zm0 10a2 2 0 0 1 2-2h15a2 2 0 1 1 0 4h-15a2 2 0 0 1-2-2ZM17.42 0a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.08a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-2.08Zm-2 18a2 2 0 0 1 2-2h2.08a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2.08a2 2 0 0 1-2-2v-4ZM4.5 16a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h6.4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2H4.5Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgDashboard;
